import { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Icon from "../../Icons/general/Icon";

const TOAST_STYLES = {
  Success: {
    container: "bg-green-100 border-green-500",
    text: "text-green-600",
    icon: "fill-green-500",
    button: "bg-green-100 hover:bg-green-300",
    svg: "checkCircle",
  },
  Danger: {
    container: "bg-red-100 border-red-500",
    text: "text-red-600",
    icon: "fill-red-500",
    button: "bg-red-100 hover:bg-red-300",
    svg: "errorCircle",
  },
  Warning: {
    container: "bg-yellow-100 border-yellow-500",
    text: "text-yellow-600",
    icon: "fill-yellow-500",
    button: "bg-yellow-100 hover:bg-yellow-300",
    svg: "warning",
  },
  Info: {
    container: "bg-blue-100 border-blue-500",
    text: "text-blue-600",
    icon: "fill-blue-500",
    button: "bg-blue-100 hover:bg-blue-300",
    svg: "infoCircle",
  },
};

function Toasts({ type = "Danger", message, active }) {
  const [show, setShow] = useState(active);
  const timer = useRef(null);

  const style = TOAST_STYLES[type] || TOAST_STYLES.Danger;

  useEffect(() => {
    setShow(active);

    if (active) {
      clearTimeout(timer.current);
      timer.current = setTimeout(() => {
        setShow(false);
      }, 10000);
    }

    return () => clearTimeout(timer.current);
  }, [active, type, message]);

  const CloseToast = () => {
    clearTimeout(timer.current);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      className={`fixed z-[9999] top-5 right-7 h-auto max-w-xs p-4 text-gray-500 rounded-lg border ${style.container}`}
      role="alert"
    >
      <div className="flex">
        <div className="inline-flex items-center justify-center flex-shrink-0">
          <Icon
            svg={style.svg}
            className={`w-8 h-8 fill-current ${style.icon}`}
            title={type}
          />
        </div>

        <div className={`inline-flex ml-2 items-center justify-center text-sm font-normal ${style.text}`}>
          {message}
        </div>

        <button
          
          className={`inline-flex items-center justify-center h-8 w-8 ml-auto text-gray-600 hover:text-gray-900 rounded-lg p-1.5 ${style.button}`}
          aria-label="Close"
          onClick={CloseToast}
        >
          <span className="sr-only">Close</span>
          <svg
            className="w-3 h-3"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
          >
            <path
              stroke="currentColor"
              strokeWidth="2"
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}
Toasts.propTypes = {
  type: PropTypes.string.isRequired,
  message: PropTypes.string,
  active: PropTypes.bool,
};

export default Toasts;
